export class Struttura {
  Nome: string;
  Codice: number;
  Descrizione: string;
  Codiceazienda: number;
  Codicetipostruttura: number;

  constructor(){
    this.Nome='';
    this.Codice=0;
    this.Descrizione='';
    this.Codiceazienda=0;
    this.Codicetipostruttura=0;
  }

}
